import { gql } from '@apollo/client'

export const GET_ALL_JOB_POSITIONS = gql`
    query GetAllJobPositions($searchQuery: String, $limit: Int, $offset: Int) {
        getAllJobPositions(searchQuery: $searchQuery, limit: $limit, offset: $offset) {
            count
            rows {
                id
                name
            }
        }
    }
`
